import { SCOPE as PARENT_SCOPE } from '../types';
export const SCOPE = `${PARENT_SCOPE}.dashboard`;
export const SET_SAVING = `${SCOPE}/SET_SAVING`;
